<template>
  <div id="privilege-info">
    <div class="position-relative w-100">
      <div class="privilege-step">
        <step-navbar
          :step-active="stepActive"
          :tab-list="[
            'Information',
            'Image',
            'Tag',
            'Criteria',
            'Extra/Payload',
          ]"
        />
        <privilege-info-overall class="d-none" />
      </div>
      <div class="privilege-tab">
        <div class="row">
          <div class="col-12">
            <div class="position-relative">
              <!-- <div
                v-if="!modeEditor"
                class="position-absolute top-0 right-0"
              >
                Edit Button
              </div> -->
              <b-tabs v-model="stepActive" class="custom-tab">
                <b-tab
                  :title="'Information'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 0 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <privilege-information
                    :is-edit="!modeEditor"
                    :privilege-id="privilegeId"
                    @onNextStep="stepActive++"
                    @onGetPrivilegeId="onGetPrivilegeId"
                  />
                </b-tab>
                <b-tab
                  :title="'Image'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 1 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <privilege-image
                    :is-edit="!modeEditor"
                    :privilege-id="privilegeId"
                    @onNextStep="stepActive++"
                    @onPreviousStep="stepActive--"
                    @onGetPrivilegeId="onGetPrivilegeId"
                  />
                </b-tab>
                <b-tab
                  :title="'Tag'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 2 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <privilege-tag
                    :is-edit="!modeEditor"
                    :privilege-id="privilegeId"
                    @onNextStep="stepActive++"
                    @onPreviousStep="stepActive--"
                    @onGetPrivilegeId="onGetPrivilegeId"
                  />
                </b-tab>
                <b-tab
                  :title="'Criteria'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 3 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <privilege-criteria
                    :is-edit="!modeEditor"
                    :privilege-id="privilegeId"
                    @onNextStep="stepActive++"
                    @onPreviousStep="stepActive--"
                    @onGetPrivilegeId="onGetPrivilegeId"
                  />
                </b-tab>
                <b-tab
                  :title="'Extra/Payload'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 4 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <privilege-extra-payload
                    :is-edit="!modeEditor"
                    :privilege-id="privilegeId"
                    @onPreviousStep="stepActive--"
                    @onGetPrivilegeId="onGetPrivilegeId"
                  />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrivilegeInfoOverall from "./components/dashboard/PrivilegeInfoOverAll.vue";
import PrivilegeInformation from "./components/PrivilegeInformation.vue";
import PrivilegeImage from "./components/PrivilegeImage.vue";
import PrivilegeTag from "./components/PrivilegeTag.vue";
import PrivilegeCriteria from "./components/PrivilegeCriteria.vue";
import PrivilegeExtraPayload from "./components/PrivilegeExtraPayload.vue";
import usePrivilegeInfo from "./hooks/usePrivilegeInfo";

export default {
  components: {
    PrivilegeInfoOverall,
    PrivilegeInformation,
    PrivilegeImage,
    PrivilegeTag,
    PrivilegeCriteria,
    PrivilegeExtraPayload,
  },
  setup() {
    const {
      modeEditor,
      stepActive,
      privilegeId,
      onGetPrivilegeId,
      onNextStep,
      onPreviousStep,
    } = usePrivilegeInfo();

    return {
      modeEditor,
      stepActive,
      privilegeId,
      onGetPrivilegeId,
      onNextStep,
      onPreviousStep,
    };
  },
};
</script>

<style scope>
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/tag-dropdown.css";
@import "~@/assets/css/pages/privilege/privilege-image-modal.css";
@import "~@/assets/css/pages/privilege/privilege-information.css";
@import "~@/assets/css/pages/privilege/privilege-form.css";
@import "~@/assets/css/override-styles/progress-nav.css";
</style>
